export const cascaderFilter = (inputValue, path) => {
  return path.some(
    option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
  );
};

export const selectFilter = (inputValue, option) => {
  return option.label.toLowerCase().includes(inputValue.toLowerCase());
};
